import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.css'],
    standalone: false
})
export class QrCodeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
